// Turkish translations
const tr = {
  // Navigation
  nav: {
    home: "Ana Sayfa",
    applyForVisa: "Vize Başvurusu",
    trackApplication: "Başvuru Takibi",
  },
  
  // Home page
  home: {
    heroTitle: "BAE'ye Açılan Kapınız",
    heroSubtitle: "Hızlı, güvenilir ve sorunsuz vize işleme hizmetleri",
    getStarted: "Başlayın",
    trackApplication: "Başvuru Takibi",
    whyChooseUs: "Neden Bizi Seçmelisiniz",
    feature1Title: "Hızlı İşlem",
    feature1Desc: "Verimli sistemimizle vizenizi hızlıca işleyin",
    feature2Title: "Güvenli ve Güvenilir",
    feature2Desc: "Belgeleriniz en üst düzey güvenlikle işlenir",
    feature3Title: "7/24 Destek",
    feature3Desc: "Ekibimiz size yardımcı olmak için her zaman burada",
    feature4Title: "Uygun Fiyatlar",
    feature4Desc: "Tüm vize türleri için rekabetçi fiyatlandırma",
  },
  
  // Visa Application
  apply: {
    title: "Vize Başvurusu",
    subtitle: "BAE vizeniz için aşağıdaki formu doldurun",
    step1: "İletişim Bilgileri",
    step2: "Kişisel Bilgiler",
    step3: "Belgeler",
    step4: "Aile Üyeleri",
    step5: "İnceleme ve Ödeme",
    
    // Step 1
    nationality: "Uyruk",
    selectNationality: "Uyruğunuzu seçin",
    visaDuration: "Vize Süresi",
    selectDuration: "Vize süresini seçin",
    days30: "30 Günlük Vize",
    days60: "60 Günlük Vize",
    visaFee: "Vize Ücreti",
    perPerson: "kişi başı",
    email: "E-posta Adresi",
    emailPlaceholder: "E-postanızı girin",
    phone: "Telefon Numarası",
    phonePlaceholder: "Telefon numaranızı girin",
    
    // Step 2
    firstName: "Ad",
    lastName: "Soyad",
    fatherName: "Baba Adı",
    passportNumber: "Pasaport Numarası",
    placeOfBirth: "Doğum Yeri",
    
    // Step 3
    uploadDocuments: "Belgeleri Yükleyin",
    passportPhoto: "Pasaport Fotoğrafı",
    personalPhoto: "Kişisel Fotoğraf",
    idCardFront: "Kimlik Ön Yüzü",
    idCardBack: "Kimlik Arka Yüzü",
    uploadFile: "Dosya yükle",
    
    // Step 4
    familyMembers: "Aile Üyeleri",
    addFamilyMember: "Aile Üyesi Ekle",
    removeMember: "Kaldır",
    familyMemberDetails: "Aile Üyesi Bilgileri",
    
    // Step 5
    reviewApplication: "Başvurunuzu İnceleyin",
    applicantInfo: "Başvuru Sahibi Bilgileri",
    totalApplicants: "Toplam Başvuru Sahibi",
    totalFee: "Toplam Ücret",
    submitApplication: "Başvuruyu Gönder",
    processing: "İşleniyor...",
    
    // Navigation
    next: "İleri",
    previous: "Geri",
    submit: "Gönder",
  },
  
  // Track Application
  track: {
    title: "Başvurunuzu Takip Edin",
    subtitle: "Tüm vize başvurularınızı görmek için e-postanızı girin",
    emailPlaceholder: "E-posta adresinizi girin",
    search: "Ara",
    searching: "Aranıyor...",
    noApplications: "Bu e-posta için başvuru bulunamadı",
    applicationId: "Başvuru No",
    submittedOn: "Gönderim Tarihi",
    applicantName: "Başvuru Sahibi",
    passportNumber: "Pasaport Numarası",
    visaType: "Vize Türü",
    nationality: "Uyruk",
    paymentStatus: "Ödeme Durumu",
    totalFee: "Toplam Ücret",
    paid: "Ödendi",
    pending: "Beklemede",
    adminNotes: "Yönetici Notları",
    downloadVisa: "Vizeyi İndir",
    familyMemberVisas: "Aile Üyesi Vizeleri",
  },
  
  // Payment
  payment: {
    title: "Ödeme",
    subtitle: "Vize başvurunuzu işleme almak için ödemenizi tamamlayın",
    summary: "Ödeme Özeti",
    reviewOrder: "Ödemeye geçmeden önce siparişinizi inceleyin",
    applicantName: "Başvuru Sahibi",
    nationality: "Uyruk",
    totalApplicants: "Toplam Başvuru Sahibi",
    applicationId: "Başvuru No",
    service: "Hizmet",
    visaProcessing: "Vize İşleme",
    feePerPerson: "Kişi Başı Vize Ücreti",
    totalAmount: "Toplam Tutar",
    payNow: "Şimdi Öde",
    processing: "İşleniyor...",
    securePayment: "Güvenli Ödeme",
    securePaymentDesc: "Ödemeniz Ziina üzerinden güvenli bir şekilde işlenir. Kredi/banka kartınız veya diğer desteklenen ödeme yöntemlerini kullanabilirsiniz.",
    needHelp: "Yardıma mı ihtiyacınız var? Bize ulaşın:",
  },
  
  // Payment Success
  paymentSuccess: {
    title: "Ödeme Başarılı!",
    subtitle: "Vize başvurunuz başarıyla gönderildi",
    applicationId: "Başvuru No",
    whatNext: "Sırada Ne Var?",
    step1: "Ekibimiz başvurunuzu inceleyecek",
    step2: "Başvuru durumunuz hakkında e-posta güncellemeleri alacaksınız",
    step3: "Onaylandıktan sonra vizenizi takip sayfasından indirebilirsiniz",
    trackApplication: "Başvuru Takibi",
    backHome: "Ana Sayfaya Dön",
  },
  
  // Footer
  footer: {
    description: "BAE'deki vize hizmetleri için güvenilir ortağınız. Sorunsuz vize işleme ile seyahat hayallerinizi gerçeğe dönüştürüyoruz.",
    quickLinks: "Hızlı Bağlantılar",
    contactUs: "Bize Ulaşın",
    allRights: "Tüm hakları saklıdır",
  },
  
  // Support
  support: {
    needHelp: "Yardıma mı İhtiyacınız Var?",
    description: "Destek ekibimiz vize başvurunuzda size yardımcı olmak için burada.",
    emailSupport: "E-posta Desteği",
    callUs: "Bizi Arayın",
    available: "09:00 - 18:00 arası hizmetinizdeyiz (GST)",
  },
  
  // Common
  common: {
    loading: "Yükleniyor...",
    error: "Hata",
    success: "Başarılı",
    cancel: "İptal",
    save: "Kaydet",
    delete: "Sil",
    edit: "Düzenle",
    close: "Kapat",
    days: "Gün",
  },
};

export default tr;
